import { render, staticRenderFns } from "./CompetitionStageHeader.vue?vue&type=template&id=6e105ac6&scoped=true"
var script = {}
import style0 from "./CompetitionStageHeader.vue?vue&type=style&index=0&id=6e105ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e105ac6",
  null
  
)

export default component.exports